import { render, staticRenderFns } from "./ApprovalConfiguration.vue?vue&type=template&id=5d9ee900&"
import script from "./ApprovalConfiguration.vue?vue&type=script&lang=js&"
export * from "./ApprovalConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports